import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ClockCircleTwoTone } from "@ant-design/icons";
import { Alert, Form, Input, Select, Spin } from "antd";
import { ESupportTicketQuestionType } from "@devowl-wp/api-real-commerce";
import { useSupportFormQuestionType } from "../../hooks/useSupportFormQuestionType.js";
import { useSupportResponseMessages } from "../../hooks/useSupportResponseMessages.js";
import { __ } from "../../utils/i18n.js";
const SupportFormQuestionTypeField = (param)=>{
    let { forceProduct } = param;
    const questionTypes = useSupportFormQuestionType();
    const { messages: holidayMessages, loading: loadingResponseMessages, responseTime, minutesToString } = useSupportResponseMessages();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                style: {
                    display: forceProduct ? "none" : undefined
                },
                label: __("What is it about?"),
                required: true,
                shouldUpdate: (prevValues, nextValues)=>prevValues.questionType !== nextValues.questionType,
                children: (param)=>{
                    let { getFieldValue } = param;
                    const questionType = getFieldValue("questionType");
                    const responseTimeInDays = responseTime && questionType === ESupportTicketQuestionType.ProblemWithProduct ? responseTime.responseTimeInMinutesProblemWithProduct : responseTime.responseTimeInMinutes;
                    const holidayMessage = holidayMessages.length > 0 ? holidayMessages.find((message)=>message.questionType === questionType) || holidayMessages.find((message)=>message.questionType === null) : null;
                    return /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Form.Item, {
                                noStyle: true,
                                dependencies: [
                                    "product"
                                ],
                                name: "questionType",
                                rules: [
                                    {
                                        required: true,
                                        message: __("Please choose one option!")
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Select, {
                                    children: Object.keys(questionTypes).map((key)=>/*#__PURE__*/ _jsx(Select.Option, {
                                            value: questionTypes[key]["name"],
                                            children: questionTypes[key]["localized"]
                                        }, key))
                                })
                            }),
                            questionType && questionType !== ESupportTicketQuestionType.RequestCustomOffer && responseTimeInDays && (loadingResponseMessages ? /*#__PURE__*/ _jsx(Spin, {}) : /*#__PURE__*/ _jsx(Alert, {
                                icon: (holidayMessage == null ? void 0 : holidayMessage.icon) || /*#__PURE__*/ _jsx(ClockCircleTwoTone, {}),
                                showIcon: true,
                                style: {
                                    marginTop: 15
                                },
                                message: (holidayMessage == null ? void 0 : holidayMessage.message) || __("We currently respond to support requests within %s business days (Monday to Friday) on average.", minutesToString(responseTimeInDays)),
                                type: "info"
                            }))
                        ]
                    });
                }
            }),
            /*#__PURE__*/ _jsx(Form.Item, {
                noStyle: true,
                shouldUpdate: (prevValues, nextValues)=>prevValues.questionType !== nextValues.questionType,
                children: (param)=>{
                    let { getFieldValue } = param;
                    const questionType = getFieldValue("questionType");
                    return questionType === ESupportTicketQuestionType.RequestCustomOffer && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Form.Item, {
                                label: __("Company name"),
                                name: "companyName",
                                required: true,
                                rules: [
                                    {
                                        required: true,
                                        message: __("Please enter a company name!")
                                    }
                                ],
                                children: /*#__PURE__*/ _jsx(Input, {})
                            }),
                            /*#__PURE__*/ _jsx(Form.Item, {
                                label: __("Number of needed licenses"),
                                name: "numberOfNeededLicenses",
                                required: true,
                                rules: [
                                    {
                                        type: "number",
                                        min: 1,
                                        max: 9999,
                                        required: true,
                                        transform: (v)=>+v,
                                        message: __("Please enter a number between 1 and 9999!")
                                    }
                                ],
                                extra: __("If you are still unsure, please enter a rough estimate of how many licenses you need."),
                                children: /*#__PURE__*/ _jsx(Input, {
                                    type: "number",
                                    style: {
                                        width: 100
                                    }
                                })
                            })
                        ]
                    });
                }
            })
        ]
    });
};
export { SupportFormQuestionTypeField };
